if (!customElements.get('ni-product-reviews')) {
  customElements.define('ni-product-reviews', class extends HTMLElement {
    connectedCallback() {
      this.reviews = document.querySelector('section[id$="__ni_judgeme_reviews"]');
      const product = this.closest('product-info');
      if (!this.reviews || !product?.querySelector('media-gallery')) return;
      this.marker = document.createElement('div');
      this.marker.hidden = true;
      this.reviews.before(this.marker);
      this.breakpoint = window.matchMedia('(min-width: 750px)');
      this.placeReviews = () => {
        const desktop = this.breakpoint.matches;
        this.parentElement?.classList.toggle('ni-has-media-reviews', desktop);
        if (desktop) {
          if (this.reviews.parentElement !== this) this.append(this.reviews);
        } else if (this.reviews.previousElementSibling !== this.marker) {
          this.marker.after(this.reviews);
        }
      };
      this.breakpoint.addEventListener('change', this.placeReviews);
      this.placeReviews();
    }

    disconnectedCallback() {
      if (!this.breakpoint) return;
      this.breakpoint.removeEventListener('change', this.placeReviews);
      if (this.marker.isConnected) this.marker.replaceWith(this.reviews);
    }
  });
}
